import styled from "@mui/material/styles/styled";
import { Box } from "../../..";
const BoxStyled = styled(Box)`
 margin: 0 12px;
 padding: 12px 0 16px;
 border-top: 1px solid var(--mui-palette-lines-divider);
 display: flex;
 justify-content: flex-end;
`;
export {
  BoxStyled
};
